<template>
  <div class="client-template">
    <div class="container-fluid container-top-bar">
      <div class="row">
        <div class="col-lg-12 top-bar-client d-flex justify-content-end">
          <router-link :to="{ name: 'client.login' }" v-if="!loggedClient">
            <span class="red_primary_text">Entrar</span>
          </router-link>
          <div class="user-logged" v-if="loggedClient">
            <span class="red_primary_text">
              Olá,
              <b>{{getFirstNameUser()}}</b>
            </span>
            <div class="logout">
              <span class="red_primary_text" v-on:click="logout()">Sair</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-12 banner-col"></div>
        <!-- <div class="col-lg-3 col-12 logo-col">
                    <span>Governet</span>
        </div>-->
        <div class="col-lg-9 col-12 menu-bar d-flex align-items-stretch" style="height: 70px;">
          <menu-item-component v-for="(item, index) in menuList" :item="item" v-bind:key="index"></menu-item-component>
        </div>
      </div>
    </div>
    <main>
      <router-view></router-view>
    </main>
    <div class="footer w-100">
      <div class="main-container w-100">
        <div class="container">
          <div class="row">
            <div class="col-lg-4 col-12 about">
              <b>Governet Editora Ltda. -EPP</b>
              <br />
              <br />
              <!-- <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat</span> -->
              <div>
                <strong>CNPJ/MF</strong> nº 07.316.919/0001-38
              </div>
              <div>
                <strong>Endereço:</strong> Sede Administrativa: Rua Waldemar Kost, 2170 – Casa 11, 
                Condomínio Eldorado II CJ RES.
                <br />
                Bairro: HAUER – CEP 81630-180
                <br />
                Curitiba/PR
              </div>
              <div>
                <strong>Telefone:</strong>  (41) 99885-4870
              </div>
              <div>
                <strong>E-mail:</strong>
                &nbsp;&nbsp;&nbsp;governet@governet.com.br
                <br />&nbsp;&nbsp;&nbsp;atendimento@governet.com.br
              </div>
            </div>
            <div class="col-lg-4 col-12 newsletter">
              <b>Receba nossas novidades</b>
              <br />
              <br />
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="newsletter.email"
                  placeholder="Informe seu e-mail"
                />
                <button class="btn btn-primary" v-on:click="saveEmailNewsletter()">
                  <i class="fa fa-paper-plane" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div class="col-lg-4 col-12 lastnews">
              <b>Últimas noticias</b>
              <br />
              <div class="lastnew" v-for="(item, index) in lastNews" v-bind:key="index">
                <router-link :to="{ name: 'public.view-news', params:{id: item.id} }">
                  <div class="title-new">
                    <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                    <span>{{item.title}}</span>
                  </div>
                  <div class="time-ago">
                    <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                    <span>{{ getDiff(item.created_at) }}</span>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sub-container w-100">
        <div class="container">
          <div class="row">
            <div class="col-12 copyright">
              <i class="fa fa-copyright" aria-hidden="true"></i>&nbsp;
              <span>Todos os direitos reservados</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuItemComponent from "@/components/menu/MenuItemComponent";
import auth from "@/api/auth";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "client-template",
  components: {
    MenuItemComponent
  },
  data() {
    return {
      perPage: 3,
      currentPageNews: 1,
      rowsNews: 0,
      lastNews: [],
      loggedClient: false,
      newsletter: {},
      menuList: [
        {
          label: "Início",
          route: "Home",
          items: [],
          active: false
        },
        {
          label: "Notícias",
          route: "public.recent-news",
          items: [],
          active: false
        },
        {
          label: "Nossos Produtos",
          route: "",
          items: [
            {
              label: "Banco de Dados",
              route: "public.search-texts"
            },
            {
              label: "Legislação",
              route: "public.legislations"
            }
          ],
          active: false
        },
        {
          label: "Colaboradores",
          route: "public.collaborators",
          items: [],
          active: false
        },
        {
          label: "Outros serviços",
          route: "",
          items: [
            {
              label: "Certidões",
              route: "public.certificates"
            },
            {
              label: "Súmulas",
              route: "public.summaries"
            }
          ],
          active: false
        },
        {
          label: "Contato",
          route: "",
          items: [
            {
              label: "Fale Conosco",
              route: "public.contact"
            },
            {
              label: "Assine já",
              route: "public.subscribe"
            },
            {
              label: "Trabalhe Conosco",
              route: "public.work_us"
            }
          ],
          active: false
        },
        {
          label: "Sobre a Governet",
          route: "public.about",
          items: [],
          active: false
        }
      ]
    };
  },
  mounted() {
    this.getLastNews();
    this.loggedClient =
      localStorage.getItem("auth.user_id") != null &&
      localStorage.getItem("auth.user_id") != "";
    if (this.loggedClient) {
      this.menuList.push({
        label: "Área do Cliente",
        route: "client.dashboard",
        items: [],
        active: false
      });
    }
  },
  methods: {
    getFirstNameUser() {
      if (localStorage.getItem("auth.user_name")) {
        let name = localStorage.getItem("auth.user_name");
        return name.split(" ")[0];
      }
      return "";
    },
    logout() {
      auth
        .logout()
        .then(data => {
          window.location.href = "/";
        })
        .catch(error => {});
    },
    getLastNews: function() {
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/news_public?page[number]=${this.currentPageNews}&page[size]=${this.perPage}&sort=-id`
        )
        .then(response => {
          this.rowsNews = response.data.total;
          this.lastNews = response.data.data;
        });
    },
    saveEmailNewsletter: function() {
      if (this.newsletter.email) {
        let promise = axios.post(
          `${process.env.VUE_APP_API_HOST}/api/email_newsletters_public`,
          this.newsletter
        );
        bus.$emit("changeLoading", true);
        promise
          .then(response => {
            bus.$emit("changeLoading", false);
            this.newsletter.email = "";
            Swal.fire({
              title: "Email cadastrado!",
              text:
                "A partir de agora você receberá todas as novidades da Governet",
              icon: "success"
            });
          })
          .catch(error => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      }
    },
    getDiff(date) {
      let now = moment();
      let diff = now.diff(date, "minutes");
      if (diff < 0) {
        return "";
      }
      if (diff < 60) {
        return diff != 0 ? diff + " Minutos atrás" : "Agora";
      } else if (diff > 10080) {
        let weeks = Math.floor(diff / 10080);
        return weeks + " semana" + (weeks == 1 ? "" : "s") + " atrás";
      } else if (diff > 1440) {
        let days = Math.floor(diff / 1440);
        return days + " dia" + (days == 1 ? "" : "s") + " atrás";
      } else {
        let hours = Math.floor(diff / 60);
        return hours + " Hora" + (hours == 1 ? "" : "s") + " atrás";
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/client/ClientLayout.scss";
</style>